import {
    Datagrid,
    TextField,
    DateField,
    NumberField,
    BooleanField,
    Record,
    FunctionField,
    SelectField,
    ArrayField,
    ChipField,
    SingleFieldList,
    ReferenceArrayField,
    SelectInput,
    Button,
    Identifier,
} from "react-admin";
import {DriverField} from "../../components/DriverField";
import {CarrierField} from "../../components/CarrierField";
import {VehicleField} from "../../components/VehicleField";
import {DatagridPropsWithOptions} from "../../shared/types";
import {getFileNameFromContentDisposition, initField} from "../../shared/utils";
import {GoToDeliveriesButton} from "../../components/GoToDeliveriesButton";
import {GoToCachetsButton} from "../../components/GoToCachetsButton";
import {DownloadFileButton} from "../../components/DownloadFileButton";
import {IdentifierField} from "../../components/IdentifierField";
import React from "react";

import TocIcon from '@material-ui/icons/Toc';
import {getUser} from "../../authProvider";
import {DownloadNoteFileButton} from "../../components/DownloadNoteFileButton";
import {clientNoJson} from "../../dataProvider";
import {url} from "../../constants";
import {Typography} from "@material-ui/core";
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import CloseIcon from '@material-ui/icons/Close';
import {Route} from "react-router-dom";
import {RouteField} from "../../components/RouteField";

let green = "rgb(76, 175, 80)";
let yellow = "rgb(255, 152, 0)";
let red = "#f44336";

export const downloadNote = async (routeId: Identifier, resource?: string) => {
    if (!resource) {
        resource = "notes"
    }
    let res = null;
    try {
        res = await clientNoJson(`${url}/${`${resource}/${routeId}/download/`}`, {
            responseType: "arraybuffer",
            method: "GET",
        });
    } catch (err) {
        return;
    }
    return res;
};


const deliverYTypeCount = (
    type: string,
    label: string,
    color: string
) => {

    return (

        <FunctionField
            render={(record: Record | undefined) =>
                (record && record.total_delivery_types) ? (
                    <div
                        style={{
                            width: "100%",
                            //borderRight: "1px solid black",
                            color: color,
                            textAlign: "right"
                        }}>
                        <Typography>
                            {record.total_delivery_types[type]}
                        </Typography>

                    </div>
                ) : null
            }
            label={label}
        />
    )

}

export const saveNoteToFile = async (routeId: Identifier) => {
    const res = await downloadNote(routeId, "routes");
    if (res) {
        const data = res.data;
        const url = window.URL.createObjectURL(
            new Blob([data], {
                type: res.headers["content-type"],
            })
        );
        const actualFileName = getFileNameFromContentDisposition(
            res.headers["content-disposition"]
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", actualFileName);
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) link.parentNode.removeChild(link);
    }
};

export const RouteSummaryDatagrid = ({
                                         options,
                                         ...rest
                                     }: DatagridPropsWithOptions) => {

    return (
        <Datagrid {...rest}>
            <RouteField routeSource={"id"} {...initField("id", options)} />
            <SelectField
                choices={options.status.choices}
                {...initField("status", options, "array")}
            />
            <DateField {...initField("planned_date", options)} showTime/>
            <ArrayField source="tags_objects" label="Tag" sortable={false}>
                <SingleFieldList>
                    <FunctionField
                        render={(record: any) => (
                            <ChipField size="small" source="label"/>
                        )}
                    />
                </SingleFieldList>
            </ArrayField>
            <FunctionField
                label={"Autista/Vettore"}
                render={(record: Record | undefined) =>
                    record ? (
                        record.driver ? (<DriverField {...initField("driver", options)} />) : (
                            <CarrierField {...initField("carrier", options)} />)
                    ) : null
                }/>
            <VehicleField {...initField("vehicle", options)} sortBy="vehicle__internal_code"/>
            <FunctionField
                source="total_distance"
                render={(record: any) => (
                    <Typography>{record.total_distance || 0} km</Typography>
                )} label="Tot. km"/>
            <NumberField {...initField("total_receivers", options)} />
            <NumberField {...initField("total_packages_number", options)} />
            <NumberField {...initField("total_weight", options)} />
            <NumberField {...initField("total_taxable", options)} style={{fontWeight: "bold"}} />
            <NumberField {...initField("total_deliveries", options)} />
            {
                deliverYTypeCount("NO", "Cons", "green")
            }
            {
                deliverYTypeCount("RC", "Rico", "red")
            }
            {
                deliverYTypeCount("RI", "Riti", "orange")
            }
            {
                deliverYTypeCount("BA", "Resi", "gray")
            }
            {
                deliverYTypeCount("PH", "Segn", "gray")
            }
            <FunctionField
                sortable={false}
                source="deliveries_not_done"
                label={"!!!"}
                render={(tableRecord: Record | undefined) => {
                    if (!tableRecord) {
                        return null;
                    }
                    let color = green;
                    let n = tableRecord.deliveries_not_done;

                    if (tableRecord.deliveries_not_done == -1) {
                        n = "X"
                        color = green;
                    } else if (tableRecord.deliveries_not_done > 0) {
                        color = red;
                    }

                    return (
                        <div style={{
                            borderRadius: "50%",
                            width: "15px",
                            height: "15px",
                            padding: "3px",
                            background: color,
                            //border: "1px solid #000",
                            color: "#000",
                            textAlign: "center",
                            font: "14px Arial, sans-serif",
                            cursor: "pointer"
                        }}
                             title={n !== "X" ? `Numero di missioni non completate ${n.toString()}` : "Non disponibile per missioni con stato diverso da partito"}
                        >
                            <b>{n}</b>
                        </div>
                    );
                    return null;
                }}
            />
            <GoToDeliveriesButton filterAttribute={"route"} label="Miss."/>
            <GoToCachetsButton filterAttribute={"route"} label="Contr."/>
            <FunctionField
                render={(record: Record | undefined) =>
                    record ? (
                        <DownloadFileButton
                            title="Borderau pdf"
                            urlDownload={`routes/${record.id}/get_pdf_borderau/`}
                        />
                    ) : null
                }
            />
            <FunctionField
                render={(record: Record | undefined) =>
                    record ? (
                        <DownloadFileButton
                            title="Borderau excel"
                            urlDownload={`routes/${record.id}/get_excel_borderau/`}
                            icon={<TocIcon/>}
                        />
                    ) : null
                }
            />

        </Datagrid>
    );
};
